import { CustomerFormData } from '../types';

const initCustomer: CustomerFormData = {
  Name: '',
  TypeId: null,
  TypeTitle: '',
  Address: '',
  WorkPhone: '',
  CellPhone: '',
  HomePhone: '',
  WorkEmail: '',
  PersonalEmail: '',
  OtherEmail: '',
};

export default initCustomer;
